// extracted by mini-css-extract-plugin
export default {"container":"IFToastMessage_container__PrmFB","text":"IFToastMessage_text__ZwgLB","icon":"IFToastMessage_icon__AbdgQ"};